export default __webpack_public_path__ + "static/media/dark.c6a8af4c.jpg";